import React from "react";

// Client logo chips — renders the real logo image, falls back to the name wordmark.
function LogoChip({ item }) {
  const [err, setErr] = React.useState(false);
  const name = typeof item === "string" ? item : item.name;
  const logo = typeof item === "string" ? null : item.logo;
  return (
    <div className="group flex items-center justify-center min-w-[190px] h-[92px] rounded-xl border border-[rgba(10,31,60,0.1)] bg-white px-7 shadow-[0_10px_30px_-22px_rgba(10,31,60,0.4)] transition-all duration-300 hover:border-[rgba(14,122,58,0.5)] hover:shadow-[0_14px_34px_-18px_rgba(14,122,58,0.5)]">
      {logo && !err ? (
        <img
          src={logo}
          alt={name}
          loading="lazy"
          onError={() => setErr(true)}
          className="max-h-[52px] max-w-[140px] object-contain opacity-100 transition-all duration-300 group-hover:grayscale group-hover:opacity-70"
        />
      ) : (
        <span className="font-display text-lg font-semibold tracking-tight text-[#64748b] transition-colors duration-300 group-hover:text-[color:var(--rq-green)]">
          {name}
        </span>
      )}
    </div>
  );
}

export default function ClientMarquee({ items, reverse = false }) {
  const row = [...items, ...items];
  return (
    <div className="relative overflow-hidden py-2 [mask-image:linear-gradient(to_right,transparent,black_8%,black_92%,transparent)]">
      <div className={`flex w-max gap-4 ${reverse ? "rq-marquee-rev" : "rq-marquee"}`}>
        {row.map((item, i) => (
          <LogoChip key={i} item={item} />
        ))}
      </div>
    </div>
  );
}
